import React, { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import Typography from '@mui/material/Typography';
import StdDialog from 'components/Dialogs/StdDialog';
import StdDialogActions from 'components/Dialogs/StdDialogActions';
import StdDialogContent from 'components/Dialogs/StdDialogContent';

import { rootUiActions } from 'app-components/flux/root-ui';
// import { tracker } from 'app-components/utils/core';

import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
  dialog: {
    '.MuiButton-root': {
      padding: `${theme.spacing(1)} ${theme.spacing(3)}`,
      '&.MuiButton-colorError': {
        background: theme.palette.background.paper,
        color: theme.palette.error.main,
        border: `1px solid ${theme.palette.error.main}`,
      },
    },
  },
}));

type CancelTransactionRuleProps = {
  onCancel: () => void;
};

function CancelTransactionRule(props: CancelTransactionRuleProps) {
  const { classes } = useStyles();
  const { onCancel } = props;
  const dispatch = useDispatch();

  const cancelMessage = 'Are you sure you want to cancel creating this rule? Your progress will not be saved.';

  const cancelRule = () => {
    // tracker.track(tracker.events.cancelRule);
    onCancel();
    dispatch(rootUiActions.removeDialog());
  };

  const onClose = useCallback(() => dispatch(rootUiActions.removeDialog('cancel-transaction-rule-dialog')), [dispatch]);

  return (
    <StdDialog classes={{ root: classes.dialog }} onClose={onClose} open showCloseButton size='xs' title='Cancel Rule'>
      <StdDialogContent id='cancel_transaction_rule_dialog'>
        <Typography variant='titleMedium'>{cancelMessage}</Typography>
      </StdDialogContent>
      <StdDialogActions
        primary={{
          id: 'cancel-rule-button',
          children: 'Cancel rule',
          color: 'error',
          onClick: cancelRule,
        }}
        secondary={{
          id: 'cancel-close-button',
          children: 'Back To Edit',
          onClick: onClose,
        }}
      />
    </StdDialog>
  );
}

CancelTransactionRule.displayName = 'CancelTransactionRule';

export default CancelTransactionRule;
